import { useCallback } from 'react';
import firebase, { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import 'firebase/auth';
import 'firebase/database';
import {
  firebaseDevelopmentConfigs,
  firebaseStagingConfigs,
  firebaseProductionConfigs,
  firebaseSandboxConfigs,
} from './firebaseConfigs';

export const useFirebase = () => {
  const getFirebaseApp = useCallback((appIdentifier) => {
    const firebaseConfig =
      ENV === 'development'
        ? firebaseDevelopmentConfigs[appIdentifier]
        : ENV === 'staging'
        ? firebaseStagingConfigs[appIdentifier]
        : ENV === 'sandbox'
        ? firebaseSandboxConfigs[appIdentifier]
        : firebaseProductionConfigs[appIdentifier];

    const secondDatabaseName =
      ENV === 'development'
        ? 'develop-orders-a6c93'
        : ENV === 'staging'
        ? 'test-firebase-php-86f70'
        : ENV === 'sandbox'
        ? 'sandbox-orders-tracker'
        : 'smoothcommerce-orders-tracker';
    let app;
    try {
      app = firebase.app(secondDatabaseName);
    } catch (error) {
      app = firebase.initializeApp(firebaseConfig, secondDatabaseName);
    }

    const firebaseToken = localStorage.getItem('firebase_token');
    if (firebaseToken) {
      app
        .auth()
        .signInWithCustomToken(firebaseToken)
        .then(() => {
          console.log('successful firebase sign in');
        })
        .catch((error) => {
          console.log('firebase token error:', error.message);
        });
    }
    return app;
  }, []);
  const getVersionAppDB = useCallback(() => {
    const firebaseConfig = {
      apiKey: 'AIzaSyCpr5BSRrIpkmQc9jmyeODJtR78YvK_LWA',
      authDomain: 'smooth-map-5bef9.firebaseapp.com',
      projectId: 'smooth-map-5bef9',
      storageBucket: 'smooth-map-5bef9.firebasestorage.app',
      messagingSenderId: '926746138699',
      appId: '1:926746138699:web:a342f5a558e03cd0cc15ce',
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);
    return db;
  }, []);
  return { getFirebaseApp, getVersionAppDB };
};

export const getVersionDB = () => {
  const firebaseConfig = {
    apiKey: 'AIzaSyCpr5BSRrIpkmQc9jmyeODJtR78YvK_LWA',
    authDomain: 'smooth-map-5bef9.firebaseapp.com',
    projectId: 'smooth-map-5bef9',
    storageBucket: 'smooth-map-5bef9.firebasestorage.app',
    messagingSenderId: '926746138699',
    appId: '1:926746138699:web:a342f5a558e03cd0cc15ce',
  };

  // Initialize Firebase (v8 syntax)
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
  const db = firebase.firestore();
  return db;
};
